<script>
import { mapActions, mapState } from 'vuex';

export default {
   data() {
      return {
         over: false,
         asset: Object,
         imgSrc: String,
         // slotData: this.slotObject,
         instanceRecid: -1 //keeping track of an instance's recid before converting to the t_asset record
      }
   }, 

   computed: {
      ...mapState('program_block', [
         'savingAsBlock',
      ]),

      addRow() {
         return this.slotObject.assetRecid < 0;
      },

      isInstance() {
         return this.slotObject.assetType == 10;
      },

      creatorName() {
         return this.asset.c_first_name + ' ' + this.asset.c_last_name;
      },
   },

   created() {
      if (this.slotObject.assetRecid > 0) {
         this.getAssetData();
      }

      let self = this;

      this.$on('durationChange', (duration, assetRecid=-1) => {
         if (assetRecid > 0) {//dealing with a feed slot
            self.feedSlots[assetRecid].duration = duration;
            self.calculateDuration();
         } else {
            self.slotObject.c_duration = duration;
         }

         //caught by Block Display
         // EventBus.$emit('duration-change', self.slotObject.c_duration);
      });

      if (this.active) {
         this.handleActive();
      }
   },

   destroyed() {
      // EventBus.$off('assign-asset', this.handleAssignAsset);
   },

   props: {
      // order: Number,
      slotObject: Object,
      isTrigger: Boolean,
      showMP: Boolean,
      saveMe: Boolean,
      active: Boolean,
      recid: Number || String,
      atEnd: Boolean //for deciding whether to display increase order arrow
   },

   methods: {
      ...mapActions('program_block', [
         'fetchSlotAssetData',
         'deleteSlot',
         'setSaveAsBlockInitialized',
         'setSlotInitialized'
      ]),
      ...mapActions('global', [
         'openSmartCanvas'
      ]),

      save() {
         let self = this;
          if (parseInt(this.slotObject.recid) > 0) {
             //update existing
             this.update().then(() => {
               //emit save event
               // EventBus.$emit('slot-saved');
             });
          } else {
             //create new
             this.create().then(() => {
               //emit save event
               // EventBus.$emit('slot-saved');
             })
          }
      },

      create() {
         //implemented by children
      },

      update() {
         //implemented by children
      },

      fileType(assetType, filename='') {
         let fileType = '';
         switch(parseInt(assetType)) {
            case 10:
               fileType = '.bard';
               break;
            case 6: 
               fileType = '.feed';
               break;
            default:
               if (filename) {
                  fileType = '.' + filename.split('.')[1];
               }
               break;
         }
         return fileType;
      },

      calculateDuration() {
         if (this.slotObject) {
            if (this.slotObject.c_asset_type == 6) { //need to sum duration of assets
               let durSum = 0;
               if (Object.values(this.feedSlots).length > 0) {
                  for (let slot of Object.values(this.feedSlots)) {
                     if (slot.duration) {
                        durSum += parseInt(slot.duration);
                     }
                  }
               }
               this.slotObject.c_duration = durSum;
            }
         }
      },
   
      getAssetData() {
         if (!this.savingAsBlock) {
            this.fetchSlotAssetData({vm: this, slotRecid: this.slotObject.recid, assetRecid: this.slotObject.assetRecid});
         } else {
            this.setSlotInitialized();
         }

         // if (this.slotData.c_asset_fk > 0) {
         //    let assetStr = this.getAssetString(this.slotData.c_asset_type);
         //    let self = this;

         //    //get the asset data
         //    $.post(
         //       this.BARD_HOST + '/media/slot_info/' + this.slotData.c_asset_fk,
         //       {
         //          'token'      : localStorage.getItem('token')
         //       }, function(data) {
         //          if (!data.error) {
         //             self.asset = data;
         //             if (!self.slotData.c_duration) {
         //                self.slotData.c_duration = 0;
         //             }
         //             if (data.duration != undefined && data.duration != 0) {
         //                self.slotData.c_duration = data.duration;
         //                EventBus.$emit('duration-change', self.slotData.c_duration);
         //             } 
         //          } else {
         //             self.handleFailedAPICall('/' + assetStr + '/slot_info/' + this.slotData.c_asset_fk, 'SlotRow', data);
         //          }
         //       }
         //    ).fail((e) => {
         //       console.log('Error with ' + '/' + assetStr + '/slot_info/' + this.slotData.c_asset_fk + 'call: ' + e.responseText);
         //    }); 
         // }
         // if (this.slotObject.c_asset_fk > 0) {
         //    let assetStr = this.getAssetString(this.slotObject.c_asset_type);
         //    let self = this;

         //    //get the asset data
         //    $.post(
         //       this.BARD_HOST + '/media/slot_info/' + this.slotObject.c_asset_fk,
         //       {
         //          'token'      : localStorage.getItem('token')
         //       }, function(data) {
         //          if (!data.error) {
         //             self.asset = data;
         //             // if (!self.slotObject.c_duration) {
         //             //    self.slotObject.c_duration = 0;
         //             // }
         //             // if (data.duration != undefined && data.duration != 0) {
         //             //    self.slotData.c_duration = data.duration;
         //             //    EventBus.$emit('duration-change', self.slotData.c_duration);
         //             // } 
         //          } else {
         //             self.handleFailedAPICall('/' + assetStr + '/slot_info/' + this.slotObject.c_asset_fk, 'SlotRow', data);
         //          }
         //       }
         //    ).fail((e) => {
         //       console.log('Error with ' + '/' + assetStr + '/slot_info/' + this.slotObject.c_asset_fk + 'call: ' + e.responseText);
         //    }); 
         // }

      },

      handleSlotClick() {
         // let instanceSlot = false;
         // if (this.isGameBlock) {
         //    instanceSlot = this.order == 1;
         // }

         //caught by BaseDisplayAssets
         // EventBus.$emit('active-slot', this.slotObject.c_order, this.slotObject.c_asset_fk);
      },

      /*
       * Turn on listener for when an asset is clicked in the Media Picker
       */
      handleActive() {
         // EventBus.$on('assign-asset', this.handleAssignAsset); //assign an asset to a zone
      },

      /*
       * Assign a new asset to the slot.
       */
      // handleAssignAsset(asset, assetType) {
      //    let self = this;

      //    //assign asset to slot
      //    if (asset.asset_recid) {
      //       //instance/feed
      //       this.slotObject.assetRecid = asset.asset_recid;
      //    } else {
      //       this.slotObject.assetRecid = asset.recid;
      //    }
         
      //    this.slotObject.c_asset_type = assetType;
      //    this.slotObject.new = true;
      // },

      handleEditInstance() {
         //Caught by BaseBlockDisplay

         // EventBus.$emit('edit-instance', this.slotObject.assetRecid, this.slotObject.c_order);

         // let self = this;
         // EventBus.$on('edit-instance-close', () => {
         //    self.getAssetData();
         // });
         this.openSmartCanvas({vm: this, instanceRecid: this.slotObject.asset.origin_fk});
      },

      handleDeleteSlot() {
         //Caught by BaseDisplayAssets
         // EventBus.$emit('delete-slot', this.slotObject.recid);
         this.deleteSlot({slotRecid: this.slotObject.recid});
      },
   },

   watch: {

      'slotObject.assetRecid': function(newVal, oldval) {
         this.getAssetData();
      },

      'slotObject.refresh': function() {
         console.log('refresh');
      },

      saveMe() {
         if (this.saveMe) {
            this.save();
         }
      },

      /*
       * Trigger for 'activating' a slot.
       * An active slot needs to listen for an asset to be 
       * clicked from the Media Picker
       */
      active() {
         if (this.active) {
            this.handleActive();
         } else {
            //turn off the listener for when an asset is clicked in the Picker
            // EventBus.$off('assign-asset', this.handleAssignAsset);
         }
      }
   }
}
</script>

<style lang="scss" scoped>
tr, td {
   &:focus {
      outline: none;
   }
}

.slot-row {
   background: $bard-blue;
   &:focus {
      outline: none;
   }
}
.invisible {
   visibility: hidden;
}

.inactive {
   display: none;
}

.grabbable {
    cursor: move; /* fallback if grab cursor is unsupported */
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
}

 /* (Optional) Apply a "closed-hand" cursor during drag operation. */
.grabbable:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
}


</style>
